import DownloadIcon from '@mui/icons-material/Download';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { updateUserAccess } from 'src/util/util';
import { IFilterObject } from '../../milestoneTracking/MilestoneDetailModal';
import { useMonitoringVisitLog } from './useMonitoringVisitLog';

export interface ICollapseItem {
  [key: string]: boolean;
}
export const expandAllTxt = 'EXPAND ALL';
export const collapseAllTxt = 'COLLAPSE ALL';

const MonitoringVisitAuditTrail = ({ auditUsersList, auditId }: any) => {
  const [openFilterSearch, setOpenFilterSearch] = React.useState(false);
  const [auditTrailData, setAuditTrailData] = useState<any>([]);
  const [noOfAuditResults, setNoOfAuditResults] = useState(0);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { selectedApp, selectedAppSection } = useSelectedAppInfo();
  const [expandAll, setExpandAll] = React.useState(false);
  const { preferedFormatForDatePicker, preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const dispatchApp = useAppDispatch();
  const exportDateFormat = userPreferedDateFormat.includes('/')
    ? userPreferedDateFormat.replaceAll('/', '_')
    : userPreferedDateFormat.replaceAll('-', '_');
  const perPage = 10;
  const [page, setPage] = useState(1);
  const [paginatedAuditDetails, setPaginatedAuditDetails] = React.useState<any>({});
  const headers = [
    { label: 'Date of Creation', key: 'created_on' },
    { label: 'Date of Change', key: 'date_time_of_change' },
    { label: 'Project Module', key: 'audit_project_module' },
    { label: 'Module Section', key: 'audit_module_section' },
    { label: 'User Name', key: 'audit_user_name' },
    { label: 'Field Name', key: 'field_changed' },
    { label: 'Field Data', key: 'changed_data' },
    { label: 'Previous Data', key: 'data_changed_from' },
    { label: 'Reason For Change', key: 'comments' },
    { label: 'Action Type', key: 'reason_data_changed' }
  ];
  const [appliedFilterCount, setAppliedFilterCount] = useState<number>(0);

  const [csvDataDownload, setCsvDataDownload] = useState([]);
  const { auditFilterData, auditFilterError, getauditFilterData } = useMonitoringVisitLog();

  const [filterText, setFilterText] = useState('');
  const handleSearch = (event: any) => {
    const searchValue: string = event.target.value;
    setFilterText(searchValue);
    setFilteredAuditList(searchValue);
  };

  const setFilteredAuditList = (searchValue: string) => {
    if (searchValue != '') {
      filterAuditList(searchValue);
    } else {
      setNoOfAuditResults(auditTrailData.length);
      setPaginationWithGroupBy(auditTrailData, 1);
      setPage(1);
    }
  };

  const filterAuditList = (value: string) => {
    let filtered = auditTrailData.filter((data: any) => {
      if (
        data.reason_data_changed?.toLowerCase().includes(value.toLowerCase()) ||
        data.field_changed?.toLowerCase().includes(value.toLowerCase()) ||
        data.field_label?.toLowerCase().includes(value.toLowerCase()) ||
        data.changed_data?.toLowerCase().includes(value.toLowerCase()) ||
        data.audit_user_name?.toLowerCase().includes(value.toLowerCase()) ||
        data.data_changed_from?.toLowerCase().includes(value.toLowerCase())
      ) {
        return data;
      }
    });
    if (sortBy === 'Newest') {
      filtered = filtered.sort((a: any, b: any) => +new Date(b.date_time_of_change) - +new Date(a.date_time_of_change));
    } else {
      filtered = filtered.sort((a: any, b: any) => +new Date(a.date_time_of_change) - +new Date(b.date_time_of_change));
    }
    setNoOfAuditResults(filtered.length);
    setPaginationWithGroupBy(filtered, 1);
    setPage(1);
  };

  useEffect(() => {
    const csvData = auditTrailData.map((item: any) => {
      return {
        ...item,
        date_time_of_change: moment(new Date(item.date_time_of_change))
          .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
          .toString(),
        created_on: moment(new Date(item.created_on))
          .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
          .toString()
      };
    });
    setCsvDataDownload(csvData);
  }, [auditTrailData]);
  const filterPropsWithoutQueries: any = {
    all: true,
    dataEntry: true,
    dataChange: true,
    fromDate: false,
    toDate: false,
    users: false,
    eSign: true
  };
  const initialFilterObject = {
    filterProps:
      selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG
        ? { ...filterPropsWithoutQueries, fieldQuery: true }
        : filterPropsWithoutQueries,
    filterFromDate: null,
    filterToDate: null,
    filterUsers: []
  };
  const [updatedFilterObject, setUpdatedFilterObject] = useState<IFilterObject>(initialFilterObject);
  const [appliedFilterObject, setAppliedFilterObject] = useState<IFilterObject>(initialFilterObject);
  const [sortBy, setSortBy] = React.useState('Newest');
  const maxSizeOfAuditDetails = 1000;

  useEffect(() => {
    if (auditFilterData) {
      dispatchApp(hideLoader());
      setPage(1);
      setNoOfAuditResults(auditFilterData.length);
      setAuditTrailData(auditFilterData);
      setPaginationWithGroupBy(auditFilterData, 1);
    }
  }, [auditFilterData]);

  useEffect(() => {
    if (auditFilterError) {
      dispatchApp(hideLoader());
      updateUserAccess(auditFilterError, dispatchApp);
      setPaginatedAuditDetails([]);
    }
  }, [auditFilterError]);

  const getAuditHistory = async (
    recordId: string,
    startFrom: number,
    maxSize: number,
    sortOrder: string,
    filterData: any
  ) => {
    if (recordId.length !== 0) {
      dispatchApp(showLoader());
      await getauditFilterData({
        isOnlyUpdate: false,
        startFrom,
        maxSize,
        sortbyColumn: 'date_time_of_change',
        sortOrder,
        data: filterData,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        application_section: selectedAppSection
      });
    }
  };

  useEffect(() => {
    if (filterText !== '') {
      setFilteredAuditList(filterText);
    } else if (auditId.length !== 0) {
      getAuditHistory(auditId, 0, maxSizeOfAuditDetails, sortBy == 'Newest' ? 'desc' : 'asc', {
        audit_objects: {
          linked_table_id: auditId,
          audit_module_section: ['SUBJECT TRACKING', 'STUDY LOGS']
        },
        mFilters: []
      });
    }
  }, [sortBy]);

  const handleFilterApply = () => {
    let filterCount = 0;
    const tempFieldFilters: any[] = [];
    if (
      updatedFilterObject.filterProps.all ||
      updatedFilterObject.filterProps.dataChange ||
      updatedFilterObject.filterProps.dataEntry ||
      updatedFilterObject.filterProps.eSign
    ) {
      if (updatedFilterObject.filterFromDate != 'Invalid date' && updatedFilterObject.filterToDate != 'Invalid date') {
        const isToDateValid =
          updatedFilterObject.filterFromDate !== null && updatedFilterObject.filterToDate !== null
            ? moment(updatedFilterObject.filterToDate) >= moment(updatedFilterObject.filterFromDate)
            : true;
        if (isToDateValid) {
          if (updatedFilterObject.filterProps.all) {
            filterCount = 0;
          } else if (
            updatedFilterObject.filterProps.dataChange ||
            updatedFilterObject.filterProps.dataEntry ||
            updatedFilterObject.filterProps.fieldQuery ||
            updatedFilterObject.filterProps.eSign
          ) {
            filterCount = filterCount + 1;
            const dataChangedArr: string[] = [];
            if (updatedFilterObject.filterProps.dataChange) {
              dataChangedArr.push('Data Update');
            }
            if (updatedFilterObject.filterProps.dataEntry) {
              dataChangedArr.push('Data Entry');
            }
            if (updatedFilterObject.filterProps.eSign) {
              dataChangedArr.push('eSign');
            }

            tempFieldFilters.push({
              name: 'reason_data_changed',
              value: dataChangedArr,
              operation: 'in'
            });
          }
          if (updatedFilterObject.filterProps.fromDate || updatedFilterObject.filterProps.toDate) {
            filterCount = filterCount + 1;
            if (updatedFilterObject.filterFromDate) {
              if (
                updatedFilterObject.filterProps.dataChange ||
                updatedFilterObject.filterProps.dataEntry ||
                updatedFilterObject.filterProps.fieldQuery ||
                updatedFilterObject.filterProps.eSign
              ) {
                tempFieldFilters.push({
                  name: 'date_time_of_change',
                  value: updatedFilterObject.filterFromDate,
                  operation: 'greater_than_or_equal'
                });
              }
            }
            if (updatedFilterObject.filterToDate) {
              if (
                updatedFilterObject.filterProps.dataChange ||
                updatedFilterObject.filterProps.dataEntry ||
                updatedFilterObject.filterProps.fieldQuery ||
                updatedFilterObject.filterProps.eSign
              ) {
                tempFieldFilters.push({
                  name: 'date_time_of_change',
                  value: updatedFilterObject.filterToDate,
                  operation: 'less_than_or_equal'
                });
              }
            }
          }
          if (updatedFilterObject.filterProps.users) {
            if (updatedFilterObject.filterUsers.length) {
              filterCount = filterCount + 1;
              if (
                updatedFilterObject.filterProps.dataChange ||
                updatedFilterObject.filterProps.dataEntry ||
                updatedFilterObject.filterProps.fieldQuery ||
                updatedFilterObject.filterProps.eSign
              ) {
                tempFieldFilters.push({
                  name: 'audit_user_name',
                  value: updatedFilterObject.filterUsers,
                  operation: 'in'
                });
              }
            }
          }
          setAppliedFilterObject(updatedFilterObject);
          setAppliedFilterCount(filterCount);
          setOpenFilterSearch(false);

          getAuditHistory(auditId, 0, maxSizeOfAuditDetails, sortBy == 'Newest' ? 'desc' : 'asc', {
            audit_objects: {
              linked_table_id: auditId,
              audit_module_section: ['SUBJECT TRACKING', 'STUDY LOGS']
            },
            mFilters: tempFieldFilters
          });
        } else {
          dispatchApp(setMessage({ msgDetails: '', severity: 'error' }));
        }
      } else {
        dispatchApp(setMessage({ msgDetails: 'Invalid Date(s)', severity: 'error' }));
      }
    } else {
      filterCount = filterCount + 1;
      setAppliedFilterObject(updatedFilterObject);
      setAppliedFilterCount(filterCount);
      setOpenFilterSearch(false);
      setPage(1);
      setNoOfAuditResults(0);
      setAuditTrailData([]);
      setPaginationWithGroupBy([], 1);
    }
  };
  const handleFilterClear = () => {
    setUpdatedFilterObject(initialFilterObject);
    setFilterText('');
    setAppliedFilterCount(0);
  };

  const handleSortbyChange = (e: any) => {
    setSortBy(e.target.value);
  };

  useEffect(() => {
    const csvData = auditTrailData.map((item: any) => {
      return {
        ...item,
        date_time_of_change: moment(new Date(item.date_time_of_change))
          .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
          .toString(),
        created_on: moment(new Date(item.created_on))
          .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
          .toString()
      };
    });
    setCsvDataDownload(csvData);
  }, [auditTrailData]);

  const [collapseItems, setCollapseItems] = useState<ICollapseItem>({});
  const getText = () => {
    let txt = expandAllTxt;
    const expandedItems = Object.entries(collapseItems).filter(item => item[1]);
    const collapsedItems = Object.entries(collapseItems).filter(item => !item[1]);
    txt = expandAll ? collapseAllTxt : expandAllTxt;
    if (Object.entries(collapseItems).length > 0 && (collapsedItems.length > 0 || expandedItems.length > 0)) {
      if (paginatedAuditDetails.length === collapsedItems.length) {
        txt = expandAllTxt;
      } else if (paginatedAuditDetails.length === expandedItems.length) {
        txt = collapseAllTxt;
      } else {
        txt = expandAllTxt;
      }
    }
    return txt;
  };
  const handleClickExpandAll = () => {
    // setExpandAll(!expandAll);
    const expandState = getText() === expandAllTxt ? true : false;
    setCollapseItems({} as ICollapseItem);
    setExpandAll(expandState);
  };
  const handleChangeAccordions = (_: React.SyntheticEvent<Element, Event>, expanded: boolean, id: string) => {
    const newCollapse: ICollapseItem = { ...collapseItems };
    newCollapse[id] = expanded;
    setCollapseItems(newCollapse);
  };

  const getExpandAndCollapseState = (id: string): boolean => {
    let result = expandAll;
    if (collapseItems[id] !== undefined) {
      result = collapseItems[id];
    }
    return result;
  };

  const handleFormatDate = (dateString: any) => {
    return preferedDateFormat(dateString?.split('T')[0]);
  };

  const handleTimeAmPm = (time: any) => {
    const timeString = time.slice(11, 19);
    const timeString12hr = new Date(`1970-01-01T${timeString}Z`).toLocaleTimeString('en-US', {
      timeZone: 'UTC',
      hour12: true,
      hour: 'numeric',
      minute: 'numeric'
    });
    return timeString12hr;
  };
  const handlePagination = (_: React.ChangeEvent<unknown>, pageValue: number) => {
    if (pageValue !== page) {
      setPaginationWithGroupBy(auditTrailData, pageValue);
    }
    setPage(pageValue);
  };
  const setPaginationWithGroupBy = (allAuditHistory: any[], pageNumber: number) => {
    if (allAuditHistory) {
      // const datedAudit = allAuditHistory.map((el: any) => {
      //   return {
      //     ...el,
      //     date_change: String(el.date_time_of_change).split('T')[0]
      //   };
      // });
      const begin = (pageNumber - 1) * perPage;
      const paginatedResponse = allAuditHistory.slice(begin, begin + perPage);
      setPaginatedAuditDetails(groupBy(paginatedResponse));
    } else {
      setPaginatedAuditDetails(groupBy(allAuditHistory));
    }
  };
  const groupBy = (allData: any) => {
    const listOfMilestoneUpdates: any = {};
    allData.length > 0 &&
      allData.forEach((item: any) => {
        const date = item.date_time_of_change.split('T')[0];
        if (listOfMilestoneUpdates[date]) {
          listOfMilestoneUpdates[date].push(item);
        } else {
          listOfMilestoneUpdates[date] = [item];
        }
      });
    return listOfMilestoneUpdates;
  };

  const handleClickOpenFilterSearch = () => {
    setOpenFilterSearch(true);
    setUpdatedFilterObject(appliedFilterObject);
  };

  const handleCloseFilterSearch = () => {
    setOpenFilterSearch(false);
    setUpdatedFilterObject(appliedFilterObject);
  };

  const handleUsersChange = (_: any, values: any) => {
    setUpdatedFilterObject({
      ...updatedFilterObject,
      filterProps: {
        ...updatedFilterObject.filterProps,
        users: true
      },
      filterUsers: values
    });
  };
  const handleActionTypeChange = (event: any, actionType: string) => {
    const value = event.target.checked;
    let checkFilterObj = { ...updatedFilterObject };
    if (actionType === 'All') {
      checkFilterObj = {
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          all: value,
          dataChange: value,
          dataEntry: value,
          eSign: value,
          ...(selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG && { fieldQuery: value })
        }
      };
    } else {
      checkFilterObj = {
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          all: false,
          [actionType]: value
        }
      };
      if (
        selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG
          ? checkFilterObj.filterProps.dataChange &&
            checkFilterObj.filterProps.dataEntry &&
            checkFilterObj.filterProps.eSign
          : checkFilterObj.filterProps.dataChange &&
            checkFilterObj.filterProps.dataEntry &&
            checkFilterObj.filterProps.eSign &&
            checkFilterObj.filterProps.fieldQuery
      ) {
        checkFilterObj = {
          ...checkFilterObj,
          filterProps: {
            ...checkFilterObj.filterProps,
            all: true
          }
        };
      }
    }
    setUpdatedFilterObject(checkFilterObj);
  };

  const handleFilterDateChange = (dateValue: any, fromOrTo: string) => {
    if (fromOrTo === 'filterFromDate') {
      setUpdatedFilterObject({
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          fromDate: dateValue !== null ? true : false
        },
        filterFromDate:
          dateValue !== null
            ? moment(new Date(dateValue).toLocaleDateString('en-CA')).format('YYYY-MM-DD 00:00:00')
            : dateValue
      });
    } else {
      setUpdatedFilterObject({
        ...updatedFilterObject,
        filterProps: {
          ...updatedFilterObject.filterProps,
          toDate: dateValue !== null ? true : false
        },
        filterToDate:
          dateValue !== null
            ? moment(new Date(dateValue).toLocaleDateString('en-CA')).format('YYYY-MM-DD 23:59:59')
            : dateValue
      });
    }
  };
  const handlePrint = () => {
    setPaginatedAuditDetails(groupBy(auditTrailData));
    setTimeout(() => {
      window.print();
    }, 300);
    setTimeout(() => {
      setPaginationWithGroupBy(auditTrailData, page);
    }, 300);
  };
  return (
    <>
      <Loader />
      <Box sx={{ position: 'absolute', top: '14px', right: '24px' }}>
        <Stack direction="row" spacing={2} className="print-actions milestone-audit-print" id="no-print">
          <Tooltip title="Print" placement="top" arrow>
            <IconButton
              // disabled={isDisable}
              onClick={() => handlePrint()}
              className="grey-btn"
              aria-label="Print this Audit Trial document"
              disabled={auditTrailData.length === 0}
            >
              <LocalPrintshopIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download as CSV" placement="top" arrow>
            <IconButton
              className="grey-btn"
              disabled={auditTrailData.length === 0}
              aria-label="Download Audit Trial as CSV"
            >
              <CSVLink
                headers={headers}
                data={csvDataDownload}
                filename={`Monitoring_Visit_AuditTrail_${moment(new Date()).format(
                  `${exportDateFormat.toUpperCase()} HH:mm:ss`
                )}.csv`}
              >
                <DownloadIcon />
              </CSVLink>
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>
      <div className="audit-card">
            <Box sx={{ bgcolor: 'background.paper', pt: 0,'& .milestone-audit-pagination': { bottom: '8px' } }}>
                            <Box
                              bgcolor="white"
                              sx={{
                                width: '100%',
                                position: 'sticky',
                                top: '0',
                                zIndex: 100,
                                transition: 'top 300ms ease-in-out'
                              }}
                            >
                <Grid container className="search-block">
                  <Grid item md={10}>
                    <FormControl fullWidth variant="standard" sx={{ pr: 2, mt: 2 }}>
                      <TextField
                        id="input-with-icon-adornment"
                        value={filterText}
                        variant="standard"
                        placeholder="Search Audit"
                        autoFocus
                        onChange={e => handleSearch(e)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <span id="group">
                                <IconButton
                                  aria-label="more"
                                  id="search-filter-IconButton"
                                  aria-controls={openFilterSearch ? 'search-filter' : undefined}
                                  aria-expanded={openFilterSearch ? 'true' : undefined}
                                  aria-haspopup="true"
                                  onClick={handleClickOpenFilterSearch}
                                >
                                  <TuneIcon />
                                </IconButton>
                                {appliedFilterCount > 0 && (
                                  <span className="badge badge-light">{appliedFilterCount}</span>
                                )}
                              </span>
                              <PopupComponent
                                open={openFilterSearch}
                                onClose={handleCloseFilterSearch}
                                BackdropProps={{ invisible: true }}
                                child
                              >
                                <DialogTitle>
                                  <Typography variant="h6" component="div" sx={{ mb: 1 }}>
                                    Filters
                                    <Button
                                      sx={{ mr: 2, position: 'absolute', right: 0 }}
                                      variant="text"
                                      href=""
                                      onClick={handleFilterClear}
                                    >
                                      CLEAR
                                    </Button>
                                  </Typography>
                                </DialogTitle>
                                <DialogContent>
                                  <Grid container direction="row" justifyContent="space-between" className="filterAH">
                                    <Grid item md={5}>
                                      <FormControl component="fieldset" variant="standard" margin="normal">
                                        <FormLabel component="legend" sx={{ mb: 1 }}>
                                          Action Type
                                        </FormLabel>
                                        <FormGroup>
                                          <Stack direction="column" spacing={1}>
                                            <FormControlLabel
                                              sx={{ ml: 0 }}
                                              control={
                                                <Switch
                                                  checked={updatedFilterObject.filterProps.all}
                                                  onChange={(e: any) => handleActionTypeChange(e, 'All')}
                                                  size="small"
                                                />
                                              }
                                              label="All"
                                            />
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={updatedFilterObject.filterProps.dataEntry}
                                                  onChange={(e: any) => handleActionTypeChange(e, 'dataEntry')}
                                                  size="small"
                                                />
                                              }
                                              label="Data Entry"
                                            />
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={updatedFilterObject.filterProps.eSign}
                                                  onChange={(e: any) => handleActionTypeChange(e, 'eSign')}
                                                  size="small"
                                                />
                                              }
                                              label="eSign"
                                            />
                                            <FormControlLabel
                                              control={
                                                <Switch
                                                  checked={updatedFilterObject.filterProps.dataChange}
                                                  onChange={(e: any) => handleActionTypeChange(e, 'dataChange')}
                                                  size="small"
                                                />
                                              }
                                              label="Data Change"
                                            />
                                          </Stack>
                                        </FormGroup>
                                      </FormControl>
                                    </Grid>
                                    <Grid item md={7}>
                                      <FormControl fullWidth margin="normal">
                                        <FormLabel id="" sx={{ mb: 1 }}>
                                          Date
                                        </FormLabel>
                                      </FormControl>
                                      <Grid container spacing={3} sx={{ mb: 2, display: 'flex' }}>
                                        <Grid item md={6}>
                                          <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                            variant="standard"
                                            className="custom-datePicker"
                                          >
                                            <DatePicker
                                              label="From"
                                              inputFormat={userPreferedDateFormat.toUpperCase()}
                                              value={
                                                updatedFilterObject.filterFromDate !== null
                                                  ? preferedFormatForDatePicker(
                                                      updatedFilterObject.filterFromDate?.split(' ')[0]
                                                    )
                                                  : null
                                              }
                                              onChange={(newValue: Date | null) => {
                                                handleFilterDateChange(newValue, 'filterFromDate');
                                              }}
                                              renderInput={(params: any) => (
                                                <TextField {...params} variant="standard" />
                                              )}
                                            />
                                          </LocalizationProvider>
                                        </Grid>
                                        <Grid item md={6}>
                                          <LocalizationProvider
                                            dateAdapter={AdapterDayjs}
                                            variant="standard"
                                            className="custom-datePicker"
                                          >
                                            <DatePicker
                                              label="To"
                                              inputFormat={userPreferedDateFormat.toUpperCase()}
                                              value={
                                                updatedFilterObject.filterToDate !== null
                                                  ? preferedFormatForDatePicker(
                                                      updatedFilterObject.filterToDate?.split(' ')[0]
                                                    )
                                                  : null
                                              }
                                              onChange={(newValue: Date | null) => {
                                                handleFilterDateChange(newValue, 'filterToDate');
                                              }}
                                              renderInput={(params: any) => (
                                                <TextField {...params} variant="standard" />
                                              )}
                                            />
                                          </LocalizationProvider>
                                        </Grid>
                                      </Grid>

                                      <FormControl fullWidth margin="normal">
                                        <FormLabel id="" sx={{ mb: 1 }}>
                                          User
                                        </FormLabel>
                                      </FormControl>
                                      <FormControl fullWidth variant="standard">
                                        <Autocomplete
                                          multiple
                                          id="filter-select-user"
                                          options={auditUsersList}
                                          value={updatedFilterObject.filterUsers}
                                          onChange={handleUsersChange}
                                          renderInput={(params: any) => (
                                            <TextField {...params} variant="standard" label="User(s)" />
                                          )}
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                </DialogContent>
                                <DialogActions>
                                  <Grid container spacing={2}>
                                    <Grid item md={12} display="flex" justifyContent="flex-end">
                                      <Stack direction="row" spacing={2}>
                                        <Button variant="text" href="" onClick={handleFilterApply}>
                                          Apply
                                        </Button>
                                      </Stack>
                                    </Grid>
                                  </Grid>
                                </DialogActions>
                              </PopupComponent>
                            </InputAdornment>
                          )
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={2}>
                    <FormControl fullWidth variant="standard" sx={{ mb: 2 }}>
                      <InputLabel id="demo-simple-select-standard-label">Sort By</InputLabel>
                      <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={sortBy}
                        onChange={e => {
                          handleSortbyChange(e);
                        }}
                      >
                        <MenuItem value="Newest">Newest</MenuItem>
                        <MenuItem value="Oldest">Oldest</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                {Object.keys(paginatedAuditDetails).length !== 0 && (
                  <Grid container>
                    <Grid item md={8} />
                    <Grid
                      item
                      id="no-print"
                      md={4}
                      sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', mb: 0.5 }}
                    >
                      <Button onClick={handleClickExpandAll} variant="text">
                        {getText()}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                </Box>

                <Grid container>
                  <Grid item md={12} className="audit-trail-list">
                    <Grid container>
                      {Object.keys(paginatedAuditDetails).length !== 0 ? (
                        Object.keys(paginatedAuditDetails).map((item: any, index) => {
                          return (
                            <div key={index} className="accordion-result-section">
                              <Grid item md={12}>
                                <Box sx={{ mb: 2 }}>
                                  <Grid container>
                                    <Grid item md={8}>
                                      <Typography variant="h6" component="div" sx={{ mb: 1 }} className="h6-fs16">
                                        {moment(item).format('MMMM Do, YYYY')}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  {paginatedAuditDetails[item].map((updates: any) => {
                                    let data = [];
                                    if (updates.reason_data_changed.includes('Query')) {
                                      data = JSON.parse(updates.changed_data.replace(/'/g, '"'));
                                    }

                                    return !updates.reason_data_changed.includes('Query') ? (
                                      <Accordion
                                        key={updates.id}
                                        expanded={getExpandAndCollapseState(updates.id)}
                                        onChange={(e, expanded) => {
                                          handleChangeAccordions(e, expanded, updates.id);
                                        }}
                                        className="CustomAccordion-AH"
                                      >
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Box>
                                            <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                                              <Typography variant="h6" component="div">
                                                {`${'Monitoring Visit'}: ${updates.field_label}`}
                                              </Typography>
                                              <Typography variant="body2" gutterBottom>
                                                {`${handleFormatDate(updates.date_time_of_change)} `}{' '}
                                                <span>{`${handleTimeAmPm(updates.date_time_of_change)}`}</span>
                                              </Typography>
                                              <Chip
                                                label={`${updates.reason_data_changed}`}
                                                color="success"
                                                size="small"
                                              />
                                            </Stack>
                                            {updates.reason_data_changed === 'Data Entry' && (
                                              <div>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Data Entered:</strong>{' '}
                                                  {updates.field_label === 'Start Date' ||
                                                  updates.field_label === 'End Date'
                                                    ? moment(`${updates.changed_data.replace(' ', 'T')}Z`).format(
                                                        userPreferedDateFormat.toUpperCase()
                                                      )
                                                    : updates.changed_data}
                                                </Typography>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Entered By:</strong> {`${updates.audit_user_name}`}
                                                </Typography>
                                              </div>
                                            )}
                                            {updates.reason_data_changed === 'Data Update' && (
                                              <div>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Data Changed To:</strong>{' '}
                                                  {updates.field_label === 'Start Date' ||
                                                  updates.field_label === 'End Date' ||
                                                  updates.field_label === 'Actual Start Date' ||
                                                  updates.field_label === 'Actual End Date'
                                                    ? updates.changed_data !== 'None'
                                                      ? moment(`${updates.changed_data.replace(' ', 'T')}Z`).format(
                                                          `${userPreferedDateFormat.toUpperCase()} LT`
                                                        )
                                                      : updates.changed_data
                                                    : updates.changed_data}
                                                </Typography>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Previous Value:</strong>{' '}
                                                  {updates.field_label === 'Start Date' ||
                                                  updates.field_label === 'End Date' ||
                                                  updates.field_label === 'Actual Start Date' ||
                                                  updates.field_label === 'Actual End Date'
                                                    ? updates.data_changed_from !== 'None'
                                                      ? moment(
                                                          `${updates.data_changed_from.replace(' ', 'T')}Z`
                                                        ).format(`${userPreferedDateFormat.toUpperCase()} LT`)
                                                      : updates.data_changed_from
                                                    : updates.data_changed_from}
                                                </Typography>
                                              </div>
                                            )}
                                            {updates.reason_data_changed === 'eSign' && (
                                              <div>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Data Changed To:</strong>{' '}
                                                  {updates.field_label === 'Sponsor Level Signed On' ||
                                                  updates.field_label === 'Site Level Signed On'
                                                    ? updates.changed_data !== 'None'
                                                      ? moment(`${updates.changed_data.replace(' ', 'T')}Z`).format(
                                                          `${userPreferedDateFormat.toUpperCase()} LT`
                                                        )
                                                      : updates.changed_data
                                                    : updates.changed_data}
                                                </Typography>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Previous Value:</strong>{' '}
                                                  {updates.field_label === 'Sponsor Level Signed On' ||
                                                  updates.field_label === 'Site Level Signed On'
                                                    ? updates.data_changed_from !== 'None'
                                                      ? moment(
                                                          `${updates.data_changed_from.replace(' ', 'T')}Z`
                                                        ).format(`${userPreferedDateFormat.toUpperCase()} LT`)
                                                      : updates.data_changed_from === 'None'
                                                      ? ''
                                                      : updates.data_changed_from
                                                    : updates.data_changed_from === 'None'
                                                    ? ''
                                                    : updates.data_changed_from}
                                                </Typography>
                                                <Typography component="div" gutterBottom variant="body2">
                                                  <strong>Signed By:</strong> {`${updates.audit_user_name}`}
                                                </Typography>
                                              </div>
                                            )}
                                          </Box>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                          <Typography component="div" gutterBottom variant="body2">
                                            <strong>Field:</strong> {`${updates.field_label}`}
                                          </Typography>

                                          {/* <Typography component="div" gutterBottom variant="body2">
                                             <strong>Reason:</strong> 
                                            {/* “Entered wrong value” 
                                          </Typography> */}
                                        </AccordionDetails>
                                      </Accordion>
                                    ) : (
                                      <Accordion
                                        key={updates.id}
                                        expanded={getExpandAndCollapseState(updates.id)}
                                        onChange={(e, expanded) => {
                                          handleChangeAccordions(e, expanded, updates.id);
                                        }}
                                        className="CustomAccordion-AH"
                                      >
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Box>
                                            <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                                              <Typography variant="h6" component="div">
                                                {`${''}: ${updates.reason_data_changed.split('-')[1]}`}
                                              </Typography>
                                              <Typography variant="body2" gutterBottom>
                                                {`${handleFormatDate(updates.date_time_of_change)} `}{' '}
                                                <span>{`${handleTimeAmPm(updates.date_time_of_change)}`}</span>
                                              </Typography>
                                              <Chip
                                                label={`${updates.reason_data_changed.split('-')[0]}`}
                                                color="success"
                                                size="small"
                                              />
                                            </Stack>
                                          </Box>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <Typography component="div" gutterBottom variant="body2">
                                            <strong>Raised By:</strong> {data.updated_by || data.created_by}
                                          </Typography>
                                          <Typography component="div" gutterBottom variant="body2">
                                            <strong>Send To:</strong> {data.report_forward_to || data.report_send_to}
                                          </Typography>
                                          <Typography component="div" gutterBottom variant="body2">
                                            <strong>Message:</strong> {data.report_comment}
                                            {/* “Entered wrong value” */}
                                          </Typography>
                                        </AccordionDetails>
                                      </Accordion>
                                    );
                                  })}
                                </Box>
                              </Grid>
                            </div>
                          );
                        })
                      ) : (
                        <Typography
                          key={1}
                          variant="body1"
                          gutterBottom
                          sx={{ textAlign: 'center', color: 'rgba(0,0,0,0.6)', my: 4, width: '100%' }}
                        >
                          No audit trail details found for selected Monitoring Visit/field/filter criteria
                        </Typography>
                      )}
                      {auditTrailData.length > 0 && Object.keys(paginatedAuditDetails).length !== 0 && (
                        <Stack spacing={2} className="siv-pagination milestone-audit-pagination">
                          <Pagination
                            count={Math.ceil(noOfAuditResults / perPage)}
                            page={page}
                            onChange={handlePagination}
                            disabled={paginatedAuditDetails.length === 0}
                          />
                        </Stack>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
            </Box>
      </div>
    </>
  );
};

export default MonitoringVisitAuditTrail;
